import * as React from "react";
import type { SVGProps } from "react";
const SvgMagnifierWithMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 10c0 .55.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7c-.55 0-1 .45-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8a7.96 7.96 0 0 1-1.69 4.91l5.39 5.39a.996.996 0 1 1-1.41 1.41l-5.39-5.39A7.96 7.96 0 0 1 10 18m0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M20.995 22H21h-.01z" />
  </svg>
);
export default SvgMagnifierWithMinus;
